// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"7fb1a41e","189":"34be1685","763":"4c48ae60"}[chunkId] + ".chunk.js";
};